import { getFileExtension } from "../../utils/getFileExtension";
import CustomFileIcon from "../CustomFileIcon";

const FinalSubmission = ({ selectedOrder = null }) => {
  
  const { finalDeliverables, revisions } = selectedOrder;
  const completeSubmission = finalDeliverables;

  return (
    <div className="mt-[22px] flex flex-col space-y-4  max-h-[257px] overflow-y-auto scrollbar-none">
      <a className="ml-[20px] font-inter font-medium text-level-5 text-secondary leading-3 mb-0">
        Final Submissions
      </a>

      {completeSubmission && completeSubmission.map((submission, index) => {
        const fileUrl = submission;

        return (
          <h1 className="pl-4"  >
            <CustomFileIcon extension={getFileExtension(fileUrl)} key={index} url={fileUrl}/>
          </h1>
        )
      })}
      <div className="min-h-[1px] max-w-[260px] bg-[#E6E7EC] w-full ml-2 mrl-2 "></div>
      {revisions && revisions.map((revision, index) => {
        // Check if finalDeliverables exists
        if (revision?.finalDeliverables) {
          return (
            <>
              {revision.finalDeliverables.map((fileUrl, fileIndex) => {
                // Check if fileUrl is a valid URL
                try {
                  if (fileUrl) {
                    return (
                      <h1 className="pl-4" key={fileIndex} >
                        <CustomFileIcon extension={getFileExtension(fileUrl)} key={index} url={fileUrl}/>
                      </h1>
                    );
                  }

                } catch (error) {
                  console.error('Invalid URL:', fileUrl);
                  return null; // Return nothing if the URL is invalid
                }
              })}
              <div className="min-h-[1px] max-w-[260px] bg-[#E6E7EC] w-full ml-2 mrl-2 "></div>
            </>
          );
        }
        return null; // In case finalDeliverables is not present
      })}
      <div className="w-full h-[1px] rounded-full bg-[#EEEEEE]"></div>
    </div>
  );
};

export default FinalSubmission;
